import { __awaiter } from '../../node_modules/tslib/tslib.es6.js';
import React__default, { memo, useMemo } from 'react';
import { useTheme } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { getHeadersWithUniqueVisitorId } from '../../Auth/index.js';
import { wrapSearchWithProductContext } from '../utils/wrapSearchWithProductContext.js';

const fetchConversationStarters = (stacklineSku) => __awaiter(void 0, void 0, void 0, function* () {
    const headers = yield getHeadersWithUniqueVisitorId();
    const response = yield fetch(`/api-rewards/concierge/conversationStarters`, {
        method: 'POST',
        headers: Object.assign(Object.assign({}, headers), { 'Content-Type': 'application/json' }),
        body: JSON.stringify({
            stacklineSku,
        }),
    });
    if (response.ok) {
        const data = yield response.json();
        if ((data === null || data === void 0 ? void 0 : data.questions) && Array.isArray(data.questions)) {
            return data.questions;
        }
    }
    return [];
});
const ConciergeWelcomeEmbeddedComponent = ({ displayQueries, isLoadingSuggestedQueries, onSearch, pageContext, }) => {
    const theme = useTheme();
    const pageType = pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType;
    const stacklineSku = pageContext === null || pageContext === void 0 ? void 0 : pageContext.stacklineSku;
    // Fetch context-specific queries with React Query caching
    const { data: contextQueries = [], isLoading: isLoadingContextQueries } = useQuery({
        queryKey: ['conversationStarters', stacklineSku],
        queryFn: () => fetchConversationStarters(stacklineSku !== null && stacklineSku !== void 0 ? stacklineSku : ''),
        enabled: pageType === 'pdp' && !!stacklineSku,
        staleTime: 5 * 60 * 1000,
        gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    });
    // Use context queries if available, otherwise fall back to displayQueries
    const queriesToShow = useMemo(() => (contextQueries.length > 0 ? contextQueries : displayQueries), [contextQueries, displayQueries]);
    const isLoading = useMemo(() => isLoadingContextQueries || ((pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType) === 'pdp' && isLoadingSuggestedQueries), [isLoadingContextQueries, pageContext === null || pageContext === void 0 ? void 0 : pageContext.pageType, isLoadingSuggestedQueries]);
    return (React__default.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 16px',
            textAlign: 'center',
            width: '100%',
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'auto',
        } },
        React__default.createElement("div", { style: { marginBottom: '20px' } },
            React__default.createElement("h1", { className: "tw:font-bold", style: { margin: '0 0 8px 0' } }, "Let us help you find what you\u2019ve been looking for.")),
        queriesToShow.length > 0 && !isLoading && (React__default.createElement("div", { style: {
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                maxWidth: '100%',
            } }, queriesToShow.slice(0, 4).map((query, index) => (React__default.createElement("button", { key: index, onClick: () => {
                // Wrap query with product context if on a PDP
                const queryWithContext = wrapSearchWithProductContext(query, pageContext);
                onSearch(queryWithContext);
            }, style: {
                padding: '12px 16px',
                borderRadius: '8px',
                border: `1px solid ${theme.palette.divider}`,
                backgroundColor: 'transparent',
                color: theme.palette.text.primary,
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                textAlign: 'left',
                transition: 'all 0.2s ease',
                width: '100%',
            }, onMouseEnter: (e) => {
                e.currentTarget.style.backgroundColor = theme.palette.action.hover;
            }, onMouseLeave: (e) => {
                e.currentTarget.style.backgroundColor = 'transparent';
            } }, query)))))));
};
// Memoize to prevent re-renders when parent re-renders due to input changes
const ConciergeWelcomeEmbedded = memo(ConciergeWelcomeEmbeddedComponent);

export { ConciergeWelcomeEmbedded };
//# sourceMappingURL=ConciergeWelcomeEmbedded.js.map
